import type { SVGProps } from "react";
export interface CandyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CandyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CandyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.294 13.954c1.195.03 2.552.301 3.501 1.25l.17.183c.812.935 1.053 2.198 1.08 3.318.03 1.228-.191 2.515-.454 3.568a1.12 1.12 0 0 1-1.838.563c.016.01-.005-.006-.099-.035-.141-.045-.305-.078-.577-.137-.434-.094-1.268-.265-1.872-.868-.572-.572-.712-1.177-.798-1.527-.079-.316-.104-.376-.203-.474-.098-.098-.158-.124-.474-.202-.35-.087-.953-.226-1.525-.797-.604-.604-.775-1.438-.869-1.872-.059-.273-.091-.437-.136-.579-.03-.093-.047-.113-.037-.098a1.122 1.122 0 0 1 .564-1.838c1.054-.264 2.34-.484 3.567-.455m-.054 2.25a9.7 9.7 0 0 0-1.728.137l.023.107c.113.522.193.69.26.757.1.1.161.126.475.204.349.086.954.224 1.525.795.572.572.71 1.177.796 1.525.078.315.105.376.205.476l.073.053c.1.056.291.122.683.206l.105.024a9.7 9.7 0 0 0 .14-1.727c-.022-.861-.2-1.46-.47-1.824l-.123-.142c-.338-.339-.98-.567-1.964-.59Zm2.05-8.781a1.126 1.126 0 0 1 1.469.338l.061.098 5.016 9.03.051.102a1.126 1.126 0 0 1-1.957 1.087l-.062-.098-5.015-9.028-.051-.102a1.126 1.126 0 0 1 .487-1.427ZM10.6 5.58a1.125 1.125 0 0 1 1.53.438l5.015 9.028.052.104a1.126 1.126 0 0 1-1.957 1.087l-.06-.098-5.017-9.028a1.126 1.126 0 0 1 .438-1.53ZM15.2.916a1.12 1.12 0 0 1 1.047.247c-.015-.01.005.008.098.037.142.045.306.077.579.136.434.094 1.268.265 1.872.869l.195.215c.41.504.526 1.004.602 1.31.078.316.104.376.202.474.098.099.158.124.474.203.35.086.955.226 1.527.798.603.604.774 1.438.868 1.872.06.272.092.436.137.577.03.094.046.115.035.098a1.12 1.12 0 0 1-.563 1.839c-1.053.263-2.34.484-3.568.454-1.194-.03-2.552-.301-3.501-1.25s-1.22-2.306-1.25-3.5c-.03-1.228.191-2.514.455-3.568l.045-.143c.129-.325.404-.573.746-.668m1.14 2.596a9.7 9.7 0 0 0-.136 1.728c.024.983.252 1.626.59 1.964.34.34.983.568 1.967.592a9.7 9.7 0 0 0 1.727-.139l-.024-.105c-.112-.521-.191-.688-.259-.756-.1-.1-.161-.127-.476-.205-.348-.087-.953-.224-1.525-.796-.571-.571-.71-1.176-.795-1.525-.059-.235-.088-.329-.141-.402l-.063-.072c-.068-.068-.235-.148-.757-.26l-.107-.024Z"
      />
      <path
        fill={color}
        d="M16.374 12a4.375 4.375 0 1 0-8.75 0 4.375 4.375 0 0 0 8.75 0m2.25 0a6.625 6.625 0 1 1-13.249-.002 6.625 6.625 0 0 1 13.25.002Z"
      />
    </svg>
  );
}
